import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import Modal from "@/components/shared/Modal.vue";
import PelLoanOptions from "@/components/pel-loan-configuration/PelLoanOptions.vue";

interface Props {
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PelLoanOptionsModal',
  props: {
    loading: { type: Boolean, default: false }
  },
  emits: ["close", "complete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const defaultLoanOptionsStyle = computed(() => {
  return {
    modalContainer: {
      maxWidth: "100%",
    },
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    closeBtn: true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
    styleOptions: defaultLoanOptionsStyle.value
  }, {
    default: _withCtx(() => [
      (!__props.loading)
        ? (_openBlock(), _createBlock(PelLoanOptions, {
            key: 0,
            id: "multiple-term-loanOptions",
            isCurrent: true,
            showPreviousButton: false,
            loading: __props.loading,
            onComplete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('complete', $event)))
          }, null, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["styleOptions"]))
}
}

})